/*
  アパレル新作フェア フレグランス缶プレゼント（対象商品 ¥5,500以上で自動追加 / 1注文1点）
  設定は snippets/lm-fragrance-gift.liquid（place: 'init'）が window.LM_FRAGRANCE に出力。
  対象商品の判定はタグなので /cart.js では分からない → sections/lm-fragrance-gift-state を
  Section Rendering API（/?sections=）で取得し、Liquid が計算した「対象商品合計」を使う。
*/
(function () {
  var C = window.LM_FRAGRANCE;
  if (!C || !C.enabled || !C.variantId || !C.threshold) return;

  var busy = false, again = false, timer = null;
  var mutations = 0, MAX_MUTATIONS = 4;   // 暴走防止：1ページあたりのカート書き換え上限

  function money(cents) { return '¥' + Math.round(cents / 100).toLocaleString('ja-JP'); }
  function each(sel, fn) { Array.prototype.forEach.call(document.querySelectorAll(sel), fn); }

  function getState() {
    return fetch('/?sections=' + encodeURIComponent(C.section), {
      headers: { Accept: 'application/json' }, cache: 'no-store'
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json[C.section] || '';
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('[data-lm-fg-state]');
        if (!el) throw new Error('lm-fg: state not found');
        return JSON.parse(el.textContent);
      });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function render(s) {
    var remain = C.threshold - s.target;
    var pct = Math.max(0, Math.min(100, Math.round((s.target / C.threshold) * 100)));
    each('[data-lm-fg-bar]', function (el) { el.style.width = pct + '%'; });
    each('[data-lm-fg-msg]', function (el) {
      el.textContent = remain > 0
        ? '対象商品をあと' + money(remain) + 'でフレグランス缶プレゼント'
        : '🎁 フレグランス缶プレゼントの対象です（カートに自動で追加されます）';
    });
  }

  function hideAll() { each('[data-lm-fg]', function (el) { el.style.display = 'none'; }); }

  function mutate(url, body) {
    mutations++;
    return post(url, body).then(function (r) {
      if (!r.ok) { if (url.indexOf('add') > -1) hideAll(); return null; }  // 在庫切れ等
      return notifyTheme().then(getState);
    });
  }

  function inPeriod() {
    var now = Date.now();
    if (C.startAt && now < C.startAt) return false;
    if (C.endAt && now > C.endAt) return false;
    return true;
  }

  // テーマ（assets/theme.js の CartItems）は theme:cart:change で受け取った cart を使って
  // ドロワー／カート数を描き直す。最新の /cart.js を渡してから reload しないと、
  // 追加したギフトがリロードするまで表示されない。
  var selfEvent = false;
  function notifyTheme() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        selfEvent = true;
        document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        selfEvent = false;
      })
      .catch(function () {
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      });
  }

  function sync() {
    if (!inPeriod()) return;
    if (busy) { again = true; return; }
    busy = true;
    getState()
      .then(function (s) {
        var qualifies = s.target >= C.threshold;
        if (mutations >= MAX_MUTATIONS) return s;
        if (qualifies && !s.giftKey) return mutate('/cart/add.js', { items: [{ id: C.variantId, quantity: 1 }] });
        if (qualifies && s.giftQty > 1) return mutate('/cart/change.js', { id: s.giftKey, quantity: 1 });
        if (!qualifies && s.giftKey) return mutate('/cart/change.js', { id: s.giftKey, quantity: 0 });
        return s;
      })
      .then(function (s) { if (s) render(s); })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; schedule(); }
      });
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 300); }

  function onCartEvent() { if (!selfEvent) schedule(); }
  document.addEventListener('theme:cart:change', onCartEvent);
  document.addEventListener('theme:cart:reload', onCartEvent);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();

  // 0時の開始をまたいで開いているページ用：開始時刻を過ぎたら一度だけ同期する
  if (C.startAt && Date.now() < C.startAt) {
    var wait = C.startAt - Date.now() + 1000;
    if (wait < 2147483647) setTimeout(schedule, wait);
  }
})();
